import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BaiduOutlinedSvg from "@ant-design/icons-svg/es/asn/BaiduOutlined";
import AntdIcon from "../components/AntdIcon";
var BaiduOutlined = function BaiduOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BaiduOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BaiduOutlined.displayName = 'BaiduOutlined';
}
export default /*#__PURE__*/React.forwardRef(BaiduOutlined);